/**
 * ! This component/file or some other components/files that use this component/file is being shared in one or more micro-frontend.
 * ! Please be careful when editing this component. Make sure to run "yarn build:dev" and check if the "build/@types/index.d.ts" file
 * ! is being generated or not without any errors.
 */
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { STYLE } from '../../../../../constants/style';
import { toREM } from '../../../../../utils/generalUtils';

export const useStyles = makeStyles(theme =>
  createStyles({
    errorMessage: {
      color: STYLE.COLOR.ERROR_FORM,
      fontWeight: 600,
      fontSize: `${toREM(12)} !important`,
      position: 'absolute',
    },
  })
);
